import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarContent,
  SidebarFooter,
} from "react-pro-sidebar";
import "../assets/styles/scss/Sidebar.scss";
import { useSelector, useDispatch } from "react-redux";
import { toggleSidebar } from "../redux/slices/SidebarSlice";

//Icons
import {
  FiArrowLeftCircle,
  FiArrowRightCircle,
} from "react-icons/fi";

import { BsPerson, BsCode, BsGithub, BsLinkedin } from "react-icons/bs";

import { MdWorkOutline } from "react-icons/md";
import { MdOutlineSchool } from "react-icons/md";

import React from "react";
import { Link } from "react-router-dom";

export default function Sidebar() {
  const collapsed = useSelector((state) => state.sidebar.isCollaped);
  const dispatch = useDispatch();

  const handleCollapse = () => {
    dispatch(toggleSidebar());
  };

  return (
    <div className="sidebar">
      <ProSidebar collapsed={collapsed} width={200} breakPoint="sm">
        <SidebarHeader>
          <div className="sidebar-header-title">
            <Link to="/" style={{ textDecoration: "none", color: "white" }}>
              <h1>{collapsed ? "M" : "Man"}</h1>
            </Link>
          </div>
          <div className="closemenu" onClick={handleCollapse}>
            {collapsed ? <FiArrowRightCircle /> : <FiArrowLeftCircle />}
          </div>
        </SidebarHeader>
        <SidebarContent style={{ height: "800px" }}>
          <Menu iconShape="circle">
            <MenuItem icon={<BsPerson size={20} />}>
              About
              <Link to="/about" />
            </MenuItem>
            <MenuItem icon={<MdOutlineSchool size={20} />}>
              Education
              <Link to="/education" />
            </MenuItem>
            <MenuItem icon={<BsCode size={20} />}>
              Skill
              <Link to="/skill" />
            </MenuItem>
            <MenuItem icon={<MdWorkOutline size={20} />}>
              Work
              <Link to="/work" />
            </MenuItem>
          </Menu>
        </SidebarContent>
        <SidebarFooter>
          <Menu iconShape="circle">
            <MenuItem icon={<BsGithub size={20} />}>Github <a href="https://github.com/Manusea" target={"_blank"} rel="noopener noreferrer"/></MenuItem>
            <MenuItem icon={<BsLinkedin size={18} />}>Linkedin  <a href="https://www.linkedin.com/in/chanantaphon/" target={"_blank"} rel="noopener noreferrer"/></MenuItem>
          </Menu>
        </SidebarFooter>
      </ProSidebar>
    </div>
  );
}
